export { default } from "bullitttime-embermodelsgochips/models/statistic";
